import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const Terms = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className={`min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 ${isRTL ? 'font-arabic' : 'font-english'}`}>
      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className='max-w-4xl mx-auto'
        >
          <h1 className={`text-4xl font-bold text-gray-900 mb-8 ${isRTL ? 'text-right' : 'text-left'}`}>
            {t('termsConditions')}
          </h1>

          <div className='bg-white rounded-xl shadow-lg p-8 space-y-8'>
            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Acceptance of Terms
              </h2>
              <p className={`text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                By accessing and using Kuwait Chemicals' services, you acknowledge that you have read,
                understood, and agree to be bound by these Terms and Conditions. If you do not agree
                with these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Use of Service
              </h2>
              <p className={`text-gray-600 leading-relaxed mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Our service is provided for informational purposes only. While we strive to maintain
                accurate and up-to-date information, we cannot guarantee the accuracy of all
                verification results.
              </p>
              <ul className={`list-disc list-inside text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                <li>You must use the service as intended</li>
                <li>Do not attempt to bypass security measures</li>
                <li>Report any suspicious activity</li>
                <li>Do not submit false information</li>
              </ul>
            </section>

            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Limitations of Liability
              </h2>
              <p className={`text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                Kuwait Chemicals and its affiliates shall not be liable for any direct, indirect,
                incidental, special, or consequential damages resulting from the use or inability to use
                our services. This includes but is not limited to damages for loss of profits, goodwill,
                data, or other intangible losses.
              </p>
            </section>

            <section>
              <h2 className={`text-2xl font-semibold text-gray-800 mb-4 ${isRTL ? 'text-right' : 'text-left'}`}>
                Contact Information
              </h2>
              <p className={`text-gray-600 leading-relaxed ${isRTL ? 'text-right' : 'text-left'}`}>
                For any questions regarding these terms, please contact us at:
              </p>
              <ul className={`list-none text-gray-600 leading-relaxed mt-2 ${isRTL ? 'text-right' : 'text-left'}`}>
                <li>Email: legal@kuwait-chemicals.com</li>
                <li>Phone: +965 2XXX XXXX</li>
                <li>Address: Kuwait City, Kuwait</li>
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
